<template>
    <div class="card-body" v-if="isLoaded">
        <div v-if="settingCheck">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="setting-tab" data-toggle="tab" href="#settings" aria-controls="settings" role="tab" aria-selected="false">
                        <i data-feather="tool"></i>
                        Settings
                    </a>
                </li>
            </ul>
            <div class="tab-content match-height">
                <div class="tab-pane active" id="settings" aria-labelledby="settings" role="tabpanel">
                    <div class="row match-height">
                        <!-- <div class="col-md-12 col-lg-6 col-sm-12 mx-auto">
                            <lob-setting />
                        </div> -->
                        <div class="col-md-12 col-lg-6 col-sm-12 mx-auto">
                            <fax-setting />
                        </div>
                        <div class="col-md-12 col-lg-6 col-sm-12 mx-auto">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <!-- right content section -->
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            Settings
                        </div>
                    </div>
                </div>
                <!--/ right content section -->
            </div>
        </div>
    </div>
</template>
<script>
import {ref,reactive} from 'vue'
export default {
    name:'DiySettingsComponent',
    setup(){
        const isLoaded = ref(false),
        settingCheck = reactive({})
        return{
            isLoaded,
            settingCheck
        }
    },
    mounted() {
        this.getDiyCheck();
    },
    methods: {
        getDiyCheck(){
            this.isLoaded = false;
            const route = this.$router.resolve(
                {
                    name: 'settings',
                }
            );
            axios.get(route.href)
            .then(response => {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                this.isLoaded = true
                this.settingCheck = response.data.data
            })
            .catch(function (error) {
                toastr.error(error.message, 'Error!');
            });
        }
    },
}
</script>
